import validate from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_46aae15e61ec859e2727b715f611d8cf/node_modules/nuxt/dist/pages/runtime/validate.js";
import activate_45page_45global from "/opt/atlassian/pipelines/agent/build/middleware/activatePage.global.ts";
import auth_45global from "/opt/atlassian/pipelines/agent/build/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_46aae15e61ec859e2727b715f611d8cf/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  activate_45page_45global,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}